/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { NEXEDGE_INVESTMENT_PREFERENCE, NEXEDGE_MDMS_APIS } from '../../utils/constant';
import { CALL_API } from '../middleware';
import {
  EditRiskProfileBody,
  EditRiskProfileRes,
  FileType,
  JointholderRelationMaster,
  LastEditedRiskProfile,
  RiskProfileGroup,
  RiskProfileMaster,
  RMType,
  servicePreferencesMasterType,
} from '../types/api-types';
import {
  GET_DISTRIBUTOR_CODES,
  GET_DISTRIBUTOR_CODES_SUCCESS,
  GET_IFSC_DETAILS_SUCCESS,
  GET_IFSC_DETAILS,
  GET_DISTRIBUTORS_SUCCESS,
  GET_DISTRIBUTORS,
  IfscType,
  GET_RMS,
  GET_RMS_SUCCESS,
  GET_Countries_SUCCESS,
  GET_Countries,
  nationaliyType,
  GET_DISTRIBUTORS_FOR_FILTERS_SUCCESS,
  GET_DISTRIBUTORS_FOR_FILTERS,
  GET_JOINTHOLDERLIST_SUCCESS,
  GET_JOINTHOLDERLIST,
  GET_RISKPROFILEMDMS_SUCCESS,
  GET_RISKPROFILEMDMS,
  GET_SERVICEPREFERENCE_SUCCESS,
  GET_SERVICEPREFERENCE,
  GET_MASKED_AADHAR_DETAILS_SUCCESS,
  GET_MASKED_AADHAR_DETAILS,
  LocationType,
  GET_LOCATION,
  GET_LOCATION_SUCCESS,
  GET_RISK_PROFILE_GROUPS_SUCCESS,
  GET_RISK_PROFILE_GROUPS,
  GET_LAST_EDITED_RISK_PROFILE_SUCCESS,
  GET_LAST_EDITED_RISK_PROFILE,
  GET_EDIT_RISK_PROFILE_SUCCESS,
  GET_EDIT_RISK_PROFILE,
  GetUboIdentificationTypeListResponse,
  GET_UBO_IDENTIFICATION_TYPE_LIST_SUCCESS,
  GET_UBO_IDENTIFICATION_TYPE_LIST,
} from '../types/mdms';

export type Distributor = {
  id: number;
  userId: number;
  name: string;
  firstName?: string;
  type: string;
  buildingNo: string;
  streetName: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
  arnCode: string;
  panNumber: string;
  isActive: boolean | null;
  amcId: number[];
  rmId: number;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    firstName: string | null;
    lastName: string | null;
    countryCode: string;
    phone: string;
    email: string;
    role: string;
    isActive: boolean;
    password: string | null;
  };
  subdistributors?: SubDistributor[];
};

export type SubDistributor = Distributor & { distributors_RM_Code: string };

export type getDistributorsResponse = {
  userId: number;
  empCode: string;
  amcId: number;
  createdAt: string;
  updatedAt: string;
  address1: string;
  address2: string;
  address3: string;
  arnCode: string;
  id: number;
  panNumber: string;
  phone: string;
  role: string;
  firstName: string;
  distributors: Distributor[];
};

//To get distributors under RM
export const getDistributors =
  (params?: { isActive: boolean }) =>
    async (dispatch: any): Promise<getDistributorsResponse> => {
      const distributorsResponse = await dispatch({
        [CALL_API]: {
          url: `/onboarding/amc/distributors-of-rm`,
          method: 'GET',
          types: [GET_DISTRIBUTOR_CODES_SUCCESS, GET_DISTRIBUTOR_CODES],
          params,
        },
      });
      return distributorsResponse as getDistributorsResponse;
    };

export const getIFSCDetails =
  (ifscCode: string) =>
    async (dispatch: any): Promise<IfscType> => {
      const ifscResponse = await dispatch({
        [CALL_API]: {
          url: `/onboarding/ifsc/${ifscCode}`,
          method: 'GET',
          types: [GET_IFSC_DETAILS_SUCCESS, GET_IFSC_DETAILS],
          slient: true,
        },
      });
      return ifscResponse as IfscType;
    };

//To get all the distributors list who's status is active
export const getDistributorsList =
  () =>
    async (dispatch: any): Promise<Distributor[]> => {
      const distributorsResponse = (await dispatch({
        [CALL_API]: {
          url: `/onboarding/amc/distributors`,
          method: 'GET',
          types: [GET_DISTRIBUTORS_SUCCESS, GET_DISTRIBUTORS],
        },
      })) as Distributor[];
      return distributorsResponse as Distributor[];
    };

// Get the list of RMs under and return all the active rms

export type RMListFilter = {
  name?: string;
  limit?: number;
  page?: number;
  orderBy?: string;
  orderDirection?: string;
  roleType?: string;
  isActive?: boolean;
  location?: string;
};
export const getRMsList =
  (params?: RMListFilter) =>
    async (dispatch: any): Promise<RMType[]> => {
      const rmListRes = (await dispatch({
        [CALL_API]: {
          url: `/onboarding/amc/rm-list`,
          method: 'GET',
          types: [GET_RMS, GET_RMS_SUCCESS],
          params,
        },
      })) as { rms: RMType[]; limit: 10; page: 1; pages: 1; total: 1 };
      return rmListRes.rms as RMType[];
    };

export const getNationalityList =
  () =>
    async (dispatch: any): Promise<nationaliyType> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/default-countries.json`,
          method: 'GET',
          types: [GET_Countries_SUCCESS, GET_Countries],
          modifyUrl: true
        },
      });
    };

export const getDistributorsListForFilters =
  (params?: { type: string }) =>
    async (dispatch: any): Promise<Distributor[]> => {
      const distributorsResponse = (await dispatch({
        [CALL_API]: {
          url: `/onboarding/amc/distributors/list`,
          method: 'GET',
          types: [GET_DISTRIBUTORS_FOR_FILTERS_SUCCESS, GET_DISTRIBUTORS_FOR_FILTERS],
          params,
        },
      })) as Distributor[];
      return distributorsResponse as Distributor[];
    };

export const jointHolderRelationsList =
  () =>
    async (dispatch: any): Promise<JointholderRelationMaster> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/jointholder_relations_master.json`,
          method: 'GET',
          types: [GET_JOINTHOLDERLIST_SUCCESS, GET_JOINTHOLDERLIST],
          modifyUrl: true
        },
      });
    };

export const riskProfileMasterData =
  (body?: { riskProfileGroup: string | null, company: string | null }) =>
    async (dispatch: any): Promise<RiskProfileMaster> => {
      return await dispatch({
        [CALL_API]: {
          // url: '/api/mdms/riskprofile_master.json',
          url: '/onboarding/onboarding/riskProfile',
          method: 'POST',
          types: [GET_RISKPROFILEMDMS_SUCCESS, GET_RISKPROFILEMDMS],
          ...(body ? { body } : {})
        },
      });
    };

export const getRiskProfileGroups =
  () =>
    async (dispatch: any): Promise<RiskProfileGroup[]> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/onboarding/riskProfileGroups',
          method: 'GET',
          types: [GET_RISK_PROFILE_GROUPS_SUCCESS, GET_RISK_PROFILE_GROUPS],
        },
      });
    };

export const getLastEditedRiskProfile =
  (body: { clientCode: string; applicationId: string | number; }) =>
    async (dispatch: any): Promise<LastEditedRiskProfile> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/onboarding/lastEditedRiskProfile',
          method: 'POST',
          body,
          types: [GET_LAST_EDITED_RISK_PROFILE_SUCCESS, GET_LAST_EDITED_RISK_PROFILE],
        },
      });
    };

export const getEditRiskProfile =
  (body: EditRiskProfileBody) =>
    async (dispatch: any): Promise<EditRiskProfileRes> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/onboarding/editRiskProfile',
          method: 'POST',
          body,
          types: [GET_EDIT_RISK_PROFILE_SUCCESS, GET_EDIT_RISK_PROFILE],
        },
      });
    };
export const investmentPreferenceMasterData =
  () =>
    async (dispatch: any): Promise<RiskProfileMaster> => {
      return await dispatch({
        [CALL_API]: {
          url: NEXEDGE_INVESTMENT_PREFERENCE ? '/api/mdms/nexedge_investment_preference.json' : '/mdms/investment_preference.json',
          method: 'GET',
          types: [GET_RISKPROFILEMDMS_SUCCESS, GET_RISKPROFILEMDMS],
          modifyUrl: true
        },
      });
    };

export const servicePreferenceMasterData =
  () =>
    async (dispatch: any): Promise<servicePreferencesMasterType> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/service_preference.json`,
          method: 'GET',
          types: [GET_SERVICEPREFERENCE_SUCCESS, GET_SERVICEPREFERENCE],
          modifyUrl: true
        },
      });
    };
export type MaskedAadhaarBody = {
  fileId: string;
  applicationId: string;
  applicantId: string;
};
export type MaskedAadhaarResponse = FileType;
export const getMaskedAadhaar =
  (body: MaskedAadhaarBody) =>
    async (dispatch: any): Promise<MaskedAadhaarResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/get-masked-aadhar`,
          method: 'POST',
          types: [GET_MASKED_AADHAR_DETAILS_SUCCESS, GET_MASKED_AADHAR_DETAILS],
          body,
        },
      });
    };

export const getLocationList =
  () =>
    async (dispatch: any): Promise<LocationType> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/locationMaster.json`,
          method: 'GET',
          types: [GET_LOCATION_SUCCESS, GET_LOCATION],
          modifyUrl: true
        },
      });
    };

export const getUboIdentificationTypeList =
  () =>
    async (dispatch: any): Promise<GetUboIdentificationTypeListResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: `${NEXEDGE_MDMS_APIS ? '/api' : ''}/mdms/dropdown_master.json`,
          method: 'GET',
          types: [GET_UBO_IDENTIFICATION_TYPE_LIST_SUCCESS, GET_UBO_IDENTIFICATION_TYPE_LIST],
          modifyUrl: true
        },
      });
    };
